import { reduxActionFeatureChange } from '../../actions/PostAdActions/index';


export const PostAdFeaturesConstants = {
	IncludeWebsiteUrl: 'IncludeWebsiteUrl',
	IncludeMobile: 'IncludeMobile',
	// WFHPack: 'WFHPack',
	// PPAPack: 'PPAPack',
	// SpotlightPack: 'SpotlightPack',
	// GoldAd: 'GoldAd',
	// UnlimtedFreeAds: 'UnlimtedFreeAds'
};

// PostAdFeatures - Need to stored as state in redux
class PostAdFeatures {
  constructor() {
    this.initializeFeatures();
  }

  initializeFeatures () {
    this[PostAdFeaturesConstants.IncludeWebsiteUrl] = true;
    this[PostAdFeaturesConstants.IncludeMobile] = true;
    // this[PostAdFeaturesConstants.WFHPack] = false;
    // this[PostAdFeaturesConstants.PPAPack] = false;
    // this[PostAdFeaturesConstants.SpotlightPack] = false;
    // this[PostAdFeaturesConstants.GoldAd] = false;
    // this[PostAdFeaturesConstants.UnlimtedFreeAds] = false;
  }

  set(feature, value) {
    if (this.hasOwnProperty(feature))
      this[feature] = value;
  }

  get(feature) {
    if (this.hasOwnProperty(feature))
      return this.feature;
  }

  getAll() {
    let values = {};

    for (let key in this) {
      if (this.hasOwnProperty(key) && PostAdFeaturesConstants.hasOwnProperty(key)) {
        values[key] = this[key];
      }
    }

    return values;
  }
}

class PostAdFeatureHandler {
  constructor() {
    // if (instance)
    //   return instance;

    this.postAdFeatures = new PostAdFeatures();
    this.instance = this;
  }

  features = () => this.postAdFeatures;

  getAll = () => this.features().getAll();

  setFeature = (feature, value) => {
    this.features().set(feature, value);
    this.setInRedux();
  };

  setInRedux = () => reduxActionFeatureChange(this.getAll());

  getUpdatedFeatureConfig = storeValues => {
    let allFeatures = this.getAll();
    for(let feature in allFeatures) {
      if (allFeatures.hasOwnProperty(feature)) {
        let isFeatureEnabled = this.hasOwnProperty('is' + feature + 'Enabled') && this['is' + feature + 'Enabled'](storeValues);
        this.setFeature(feature, isFeatureEnabled);
      }
    }

    return this.getAll();
  };
}

// PostAdFeatureHandler is meant to be a singleton class
const instance  = new PostAdFeatureHandler();

export default instance;



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/featureHandler.js